import styled from '@emotion/styled';

export const PageWrapper = styled.div`
  height: 100dvh;
  width: 100dvw;
`;
